import { PerformanceReviewOverviewPageCompaniesLegalEntityFragment } from 'generated/resources/graphql'

import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

import { useFilter, useNewlyAddedFilters } from '../context'

type LegalEntityFilterProps = {
  legalEntities: PerformanceReviewOverviewPageCompaniesLegalEntityFragment[]
}

export const LegalEntityFilter = ({ legalEntities }: LegalEntityFilterProps) => {
  const { value, setValue } = useFilter('legalEntityIds')
  const { newlyAddedFilters } = useNewlyAddedFilters()

  const options =
    legalEntities.map((location) => ({
      label: location.name,
      value: location.id,
    })) ?? []

  if (options.length === 0) return null

  return (
    <Filter.MultipleChoice
      label={i18n.t('performance_process.reviews.filters.legal_entity')}
      value={value}
      options={options}
      onValueChange={(newValue) => setValue(newValue ?? [])}
      defaultOpen={newlyAddedFilters.includes('legalEntityIds')}
    />
  )
}
